import React from "react";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getItem } from "services/utils";
import { Constants } from "services/keyConstants";

const CustomDatePicker = (props) => {
  const {
    label = "Select Date",
    value,
    onChange,
    name,
    isLock,
    isReadOnly = false,
    dateFormat = false,
    error,
    helperText,
    dateTime = false,
    minValue = true,
    maxValue = false,
  } = props;
  
  const PickerComponent = dateTime ? DateTimePicker : DatePicker;
  const defaultDateFormatRaw = getItem(Constants.DATE_FORMATE);
  const appendTimeFormat = (format) => `${format} HH:mm`;

  const defaultDateFormat = defaultDateFormatRaw
    ? dateTime
      ? appendTimeFormat(defaultDateFormatRaw.replace(/HH:mm/g, "").trim())
      : defaultDateFormatRaw
    : dateTime
      ? "YYYY-MM-DD HH:mm"
      : "YYYY-MM-DD";

  const finalFormat =
    typeof dateFormat === "string"
      ? dateTime
        ? appendTimeFormat(dateFormat.replace(/HH:mm/g, "").trim())
        : dateFormat
      : defaultDateFormat;

  // const minDate = minValue === false ? false : (minValue === true ? Date.now() : minValue);
  // const maxDate = maxValue === false ? false : (maxValue === true ? Date.now() : maxValue);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <PickerComponent
        timeSteps={{ minutes: 1 }}
        ampm={false}
        label={isLock ? "Lock" : null}
        value={moment(value).isValid() ? moment(value) : null}
        onChange={(newValue) => {
          // Pass ISO string outside, but keep Picker value as moment
          onChange?.(newValue && moment(newValue).isValid() ? moment(newValue).toISOString() : null);
        }}
        format={finalFormat}
        disabled={isLock}
        readOnly={isReadOnly}
        // {...{
        //   ...(minDate !== false
        //     ? { [dateTime ? "minDateTime" : "minDate"]: moment(minDate) }
        //     : {}),
        //   ...(maxDate !== false
        //     ? { [dateTime ? "maxDateTime" : "maxDate"]: moment(maxDate) }
        //     : {}),
        // }}
        slotProps={{
          textField: {
            fullWidth: true,
            name,
            InputLabelProps: { shrink: true },
            InputProps: { readOnly: isReadOnly },
            error,
            helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
